module.exports = __webpack_public_path__ + "img/color-dynamics-2_en.93fdf45.jpg";